import { DynamicElementMixin } from "%/dynamic-components/render-engine/mixins/production/dynamic-element-mixin";
import { useFanPublicationStore } from "%/stores/fan-publication-store";
import LoginState from "~/dynamic-components/options/login-state";
export const PageHeaderElementMixin = {
  extends: DynamicElementMixin,
  data() {
    return {
      LoginState,
    };
  },
  methods: {
    getExampleEntity() {
      return this.getRealEntity();
    },
    async getRealEntity() {
      return {
        "publicationName": useFanPublicationStore().publicationName,
        "publicationLogo": useFanPublicationStore().publicationLogo,
        "showUpsellBanner": true,
      };
    },
  },
};
